export function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      role="img"
      aria-label="Search"
    >
      <title>Search</title>
      <path
        d="M10.8 9.9L16.2 15.3L15.5 16L10.1 10.6C9.5 11 8.9 11.4 8.3 11.6C7.6 11.9 6.9 12 6.2 12C5.1 12 4.1 11.7 3.2 11.2C2.3 10.7 1.5 9.9 1 9C0.5 8.1 0.2 7.1 0.2 6C0.2 4.9 0.5 3.9 1 3C1.5 2.1 2.3 1.3 3.2 0.8C4.1 0.3 5.1 0 6.2 0C7.3 0 8.3 0.3 9.2 0.8C10.1 1.3 10.9 2.1 11.4 3C11.9 3.9 12.2 4.9 12.2 6C12.2 6.7 12.1 7.4 11.8 8.1C11.6 8.7 11.2 9.3 10.8 9.9ZM6.2 11C7.1 11 8 10.8 8.7 10.3C9.5 9.9 10.1 9.3 10.5 8.5C11 7.8 11.2 6.9 11.2 6C11.2 5.1 11 4.3 10.5 3.5C10.1 2.7 9.5 2.1 8.7 1.7C8 1.2 7.1 1 6.2 1C5.3 1 4.5 1.2 3.7 1.7C2.9 2.1 2.3 2.7 1.9 3.5C1.4 4.3 1.2 5.1 1.2 6C1.2 6.9 1.4 7.8 1.9 8.5C2.3 9.3 2.9 9.9 3.7 10.3C4.5 10.8 5.3 11 6.2 11Z"
        fill="currentColor"
      />
    </svg>
  );
}
